import { z } from "zod";

export type PasswordCheck = {
  id: "length" | "lowercase" | "uppercase" | "digit";
  label: string;
  test: (value: string) => boolean;
};

export const passwordChecks: PasswordCheck[] = [
  { id: "length", label: "Mindestens 8 Zeichen", test: (v) => v.length >= 8 },
  { id: "lowercase", label: "Ein Kleinbuchstabe (a–z)", test: (v) => /[a-z]/.test(v) },
  { id: "uppercase", label: "Ein Großbuchstabe (A–Z)", test: (v) => /[A-Z]/.test(v) },
  { id: "digit", label: "Eine Zahl (0–9)", test: (v) => /\d/.test(v) },
];

export function isPasswordValid(password: string): boolean {
  return passwordChecks.every((c) => c.test(password));
}

export const registerSchema = z
  .object({
    firstName: z.string().trim().min(1, { message: "Bitte gib deinen Vornamen ein" }).max(50),
    lastName: z.string().trim().min(1, { message: "Bitte gib deinen Nachnamen ein" }).max(50),
    email: z.string().trim().email({ message: "Bitte gib eine gültige E-Mail-Adresse ein" }),
    password: z
      .string()
      .min(8, { message: "Das Passwort muss mindestens 8 Zeichen lang sein" })
      .max(100)
      .regex(/[a-z]/, { message: "Das Passwort muss mindestens einen Kleinbuchstaben enthalten" })
      .regex(/[A-Z]/, { message: "Das Passwort muss mindestens einen Großbuchstaben enthalten" })
      .regex(/\d/, { message: "Das Passwort muss mindestens eine Zahl enthalten" }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Die Passwörter stimmen nicht überein",
    path: ["confirmPassword"],
  });

export type RegisterFormData = z.infer<typeof registerSchema>;
